import * as cornerstone from '@cornerstonejs/core'
import * as cornerstoneTools from '@cornerstonejs/tools'
import { init as initDicomImageLoader } from '@cornerstonejs/dicom-image-loader'

let initialized = false

export async function initCornerstone() {
  if (initialized) return

  // Initialize cornerstone core
  await cornerstone.init()

  // Initialize DICOM image loader with auth headers
  // Read token at request time (not init time) to avoid stale closure
  initDicomImageLoader({
    maxWebWorkers: Math.max(1, Math.floor((navigator.hardwareConcurrency || 4) / 2)),
    beforeSend: () => {
      const token = sessionStorage.getItem('adminToken')
      if (token) {
        return { Authorization: `Bearer ${token}` }
      }
    },
  })

  // Initialize tools
  cornerstoneTools.init()

  // Add common tools
  cornerstoneTools.addTool(cornerstoneTools.WindowLevelTool)
  cornerstoneTools.addTool(cornerstoneTools.PanTool)
  cornerstoneTools.addTool(cornerstoneTools.ZoomTool)
  cornerstoneTools.addTool(cornerstoneTools.StackScrollTool)
  cornerstoneTools.addTool(cornerstoneTools.LengthTool)
  cornerstoneTools.addTool(cornerstoneTools.AngleTool)
  cornerstoneTools.addTool(cornerstoneTools.PlanarRotateTool)

  initialized = true
}

export { cornerstone, cornerstoneTools }
